import { io } from 'socket.io-client'

import { socketBaseURL } from '@/helpers/constants'

const socket = io(socketBaseURL, {
  path: '/socket.io/',
  transports: ['websocket'],
  autoConnect: false,
  upgrade: false
})

// socket.onAny((event, ...args) => {
//   store.dispatch('app/setIsSocketUpdateInProgress', true)
// })

export default socket
